export default __webpack_public_path__ + "static/Download on Steam-0d06324a1462b8fb6c879a4dec99348a.png";